import { Fragment, useEffect, useState } from "react";
import { CompanyTitledPage } from "../TitledPage";
import useArrayObject from "../../hooks/useArrayObject";
import useInputObject from "../../hooks/useInputObject";
import { getContainerShippingSummary } from "../../http/api/ContainerAPI";
import Content from "./Content";
import SearchForm from "./SearchForm";
import TransactionModal from "./TransactionModal";
import TRANSACTION_STATE from "./state/TransactionState";
import useReceiptAPI from "./useReceiptAPI";
import usePaymentAPI from "./usePaymentAPI";
import { useLocation } from "react-router-dom";
import { getBuyer } from "../../http/api/BuyerAPI";
import { getCommodityOwner } from "../../http/api/CommodityOwnerAPI";
import { getHyphenedDate } from "../../utils/utils";

const instantiateSearchForm = {
  partnerId: "",
  targetDate: getHyphenedDate(new Date()),
  isHaveRemain: true,
};

const TransactionPage = () => {
  const [openModal, setOpenModal] = useState(false);
  const location = useLocation();
  const pathMode = location?.pathname.split("/")[3];
  useEffect(() => {
    mode.setValue(
      pathMode === "payment_entry"
        ? TRANSACTION_STATE.PAYMENT
        : TRANSACTION_STATE.RECEIPT
    );
  }, [pathMode]);
  const mode = useInputObject(null);
  const transactions = useArrayObject([]);
  const allTransactions = useArrayObject([]);
  const receiptAPI = useReceiptAPI();
  const paymentAPI = usePaymentAPI();
  const searchForm = useInputObject(instantiateSearchForm);
  const paging = useInputObject({
    page: 1,
    itemsPerPage: 10,
    totalQuantity: 0,
  });
  const [commodityOwners, setCommodityOwners] = useState([]);
  const [buyers, setBuyers] = useState([]);

  async function handleSearch() {
    const { partnerId, targetDate } = searchForm.Value;
    console.log("searchData", searchForm.Value);
    if (mode.Value === TRANSACTION_STATE.RECEIPT) {
      let listReceiptInfo = receiptAPI.get({
        buyerNo: partnerId,
        receiptDate: targetDate,
      });
      convertReceiptsToTransactions(listReceiptInfo);
    }
    if (mode.Value === TRANSACTION_STATE.PAYMENT) {
      let listPaymentInfo = paymentAPI.get({
        commodityOwnerCd: partnerId,
        paymentDate: targetDate,
      });
      convertPaymentsToTransactions(listPaymentInfo);
    }
  }

  useEffect(() => {
    if (mode.Value === TRANSACTION_STATE.RECEIPT) {
      convertReceiptsToTransactions(receiptAPI.Value);
    }
    if (mode.Value === TRANSACTION_STATE.PAYMENT) {
      convertPaymentsToTransactions(paymentAPI.Value);
    }
  }, [receiptAPI.Value, paymentAPI.Value]);

  useEffect(() => {
    if (!mode.Value) return;
    setOpenModal(true);
    if (mode.Value === TRANSACTION_STATE.RECEIPT) {
      GetBuyers();
    }
    if (mode.Value === TRANSACTION_STATE.PAYMENT) {
      GetCommodityOwner();
    }
    handleSearch();
    paging.updates({ page: 1 });
  }, [mode.Value]);

  useEffect(() => {
    const startIndex = (paging.Value.page - 1) * paging.Value.itemsPerPage;
    const endIndex = startIndex + paging.Value.itemsPerPage;

    if (allTransactions.Value) {
      const newTransactions = allTransactions.Value.slice(startIndex, endIndex);
      transactions.setValue(newTransactions);
      paging.updates({ totalQuantity: allTransactions.Value.length });
    }
  }, [allTransactions.Value, paging.Value.page, paging.Value.itemsPerPage]);

  async function convertReceiptsToTransactions(receipts) {
    allTransactions.setValue(
      receipts.map((receipt) => ({
        ...receipt,
        partnerNo: receipt.buyerNo,
        partnerName: receipt.buyerName,
        divisionCd: receipt.receiptDivisionCd,
        amount: receipt.receiptAmount,
        transactionDate: getHyphenedDate(new Date(receipt.receiptDate)),
      }))
    );
  }

  async function convertPaymentsToTransactions(payments) {
    allTransactions.setValue(
      payments.map((payment) => ({
        ...payment,
        partnerNo: payment.commodityOwnerCd,
        partnerName: payment.commodityOwnerName,
        divisionCd: payment.paymentDivisionCd,
        amount: payment.paymentAmount,
        transactionDate: getHyphenedDate(new Date(payment.paymentDate)),
      }))
    );
  }

  function insertPayment(newPayment) {
    paymentAPI.insert(newPayment);
  }
  function updatePayment(newPayment) {
    paymentAPI.update(newPayment);
  }

  function convertTransactionToPayment(newObject) {
    return {
      ...newObject,
      // paymentDivisionCd: newObject.divisionCd,
      paymentAmount: newObject.amount,
      paymentDivisionCd: newObject.division.key,
      commodityOwnerCd: newObject.partnerNo,
      commodityOwnerName: newObject.partnerName,
      paymentDate: newObject.transactionDate,
      createdId: 1, //TODO JWT 追加した後削除
      updatedId: 1, //TODO JWT 追加した後削除
    };
  }

  function insertReceipt(newReceipt) {
    receiptAPI.insert(newReceipt);
  }
  function updateReceipt(newReceipt) {
    receiptAPI.update(newReceipt);
  }

  function convertTransactionToReceipt(newObject) {
    return {
      ...newObject,
      // receiptDivisionCd: newObject.divisionCd,
      receiptAmount: newObject.amount,
      receiptDivisionCd: newObject.division.key,
      buyerNo: newObject.partnerNo,
      buyerName: newObject.partnerName,
      receiptDate: newObject.transactionDate,
      createdId: 1, //TODO JWT 追加した後削除
      updatedId: 1, //TODO JWT 追加した後削除
    };
  }

  function insert(newObject) {
    if (mode.Value === TRANSACTION_STATE.RECEIPT) {
      const newReceipt = convertTransactionToReceipt(newObject);
      if (newObject.receiptId) {
        updateReceipt(newReceipt);
      } else {
        insertReceipt(newReceipt);
      }
    }

    if (mode.Value === TRANSACTION_STATE.PAYMENT) {
      const newPayment = convertTransactionToPayment(newObject);
      if (newObject.paymentId) {
        updatePayment(newPayment);
      } else {
        insertPayment(newPayment);
      }
    }
  }

  async function GetBuyers() {
    try {
      let response = await getBuyer({});
      let listInfo = response.listBuyerInfo;
      listInfo = listInfo
        .map((o) => ({
          buyerNo: o.buyerNo,
          buyerName: o.buyerName,
        }))
        .sort((a, b) => a.buyerNo - b.buyerNo);
      setBuyers(listInfo);
      console.log("買人リスト取得");
    } catch (e) {
      console.log("買人リストを取得する際にエラー発生した：", e);
    }
  }
  async function GetCommodityOwner() {
    try {
      let response = await getCommodityOwner({});
      let listCommodityOwner = response.listCommodityOwnerInfo.sort(
        (a, b) => a.commodityOwnerCd - b.commodityOwnerCd
      );
      setCommodityOwners(listCommodityOwner);
      console.log("荷主リスト取得");
    } catch (e) {
      console.log("荷主リストを取得する際にエラー発生した：", e);
    }
  }
  return (
    <Fragment>
      <CompanyTitledPage title={"入出金管理"}>
        <SearchForm
          mode={mode}
          search={handleSearch}
          commodityOwners={commodityOwners}
          buyers={buyers}
          searchForm={searchForm}
        />
        <Content
          mode={mode}
          transactions={transactions}
          setOpenModal={setOpenModal}
          paging={paging}
        />
      </CompanyTitledPage>

      <TransactionModal
        mode={mode}
        transactions={transactions}
        open={openModal}
        setOpen={setOpenModal}
        insert={insert}
        paging={paging}
        commodityOwners={commodityOwners}
        buyers={buyers}
      />
    </Fragment>
  );
};
export default TransactionPage;
